module.exports = __webpack_public_path__ + "img/box.c11cef53.webp";